import { CustomMarkdownRenderer } from 'components'
import CompanyFilter from 'features/Solve/Components/CompanyFilter'
import { usePathname } from 'hooks'
import React, { useMemo } from 'react'

import { tx } from '@twind/core'

import { useChallengeCompany } from '../../AlgoEditor.services'
import { AlgoChallenge } from '../../AlgoEditor.types'
import { topics } from '../../data'

function InstructionTab({ question }: { question: AlgoChallenge }) {
  const { isLms } = usePathname()
  const { data: challengesComapanyNames } = useChallengeCompany(question.id)

  const topic = useMemo(() => {
    const topicObj = topics.find((topic) => topic.key === question.topic)
    if (topicObj) return topicObj.label

    return '-'
  }, [question])

  return (
    <>
      <div className="flex flex-wrap gap-4 items-center mt-3">
        {!isLms && (
          <h1 className="text-2xl font-bold capitalize">{question.name}</h1>
        )}
        <div className="flex flex-row items-center">
          <div className="capitalize text-sm font-semibold bg-primary-DEFAULT text-zinc-800 rounded-lg px-1.5 py-1">
            {topic}
          </div>

          <div
            className={tx(
              'capitalize text-lg ml-4 font-medium',
              question.difficulty === 'easy'
                ? 'text-green-500'
                : question.difficulty === 'medium'
                ? 'text-yellow-500'
                : question.difficulty === 'hard'
                ? 'text-red-500'
                : 'text-blue-500'
            )}>
            {question.difficulty}
          </div>

          <div className="capitalize text-base font-semibold px-1.5 py-1 mr-3">
            Score: {question.score}
          </div>
        </div>
      </div>
      <div className="flex flex-row flex-wrap justify-start items-center gap-3 my-4">
        {challengesComapanyNames &&
          challengesComapanyNames.companies.length > 0 && (
            <CompanyFilter
              className="text-zinc-400 text-sm px-3 py-1"
              companies={challengesComapanyNames.companies}
              numberOfCompaniesToShowInitially={6}
            />
          )}
      </div>

      <div className="mt-6">
        <CustomMarkdownRenderer details={question.question_body} />
      </div>
    </>
  )
}

export default InstructionTab
